class DrawerSearchSection extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.drawerClass = "wt-drawer-search";
    this.drawer = document.querySelector(`.${this.drawerClass}`);
    this.classDrawerActive = `${this.drawerClass}--active`;
    this.pageOverlayClass = "search-overlay";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
    this.body = document.body;

    this.triggerQuery = [
      ".wt-header__search-trigger",
      ".wt-header__search__close",
      ".search-results__terms",
    ].join(", ");
    this.triggers = () => document.querySelectorAll(this.triggerQuery);

    // search stuff
    this.cachedResults = {};
    this.input = this.querySelector('input[name="q"]');
    this.clearButton = this.querySelector(".wt-header__search__clear-button");
    this.closeButton = this.querySelector(".wt-header__search__close");
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]",
    );
    this.searchProperties = this.dataset.searchProperties;

    this.mainTrigger = this.querySelector(".wt-header__search-trigger");
    this.emptyAnnouncement = this.querySelector(".search-empty");
    this.searchResultTop = this.querySelector(".search-result-top");

    this.isVisibleClearButton = false;

    this.saveSuggestionMenuInDesignMode =
      this.saveSuggestionMenuInDesignMode.bind(this);

    this.isPredictiveSearchAvailable = this.hidePredictiveSearch();
    this.isPredictiveSearchEnabled = this.dataset.enablePredictiveSearch === 'true';

    this.setupEventListeners();

    this.toggleTabindexElements = [this.input, this.closeButton];

    this.suggestionMenuContent = this.querySelector(".search-result-top").cloneNode(true);
    this.timeOut = null;
    this.init();
  }


  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input:not([type='hidden']), select, [tabindex]";
    const focusableElements = () =>
      Array.from(this.querySelectorAll(focusableElementsSelector)).filter(
        (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  // fixOverlayIssue() {
  //     const body = this.body;
  //
  //     if(body.classList.contains(this.activeOverlayBodyClass)) {
  //         const offsetTop = -parseInt(body.style.top);
  //         body.style.position = 'initial';
  //         body.style.top = 'initial';
  //         body.style.left = 'initial';
  //         window.scrollTo(0, offsetTop);
  //
  //     } else {
  //         // body.style.top = -document.documentElement.scrollTop+'px';
  //         // body.style.left = '0px';
  //         // body.style.position = 'fixed';
  //     }
  // }

  onToggle() {
    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      setTabindex(this.toggleTabindexElements, "-1");
      setTabindex([this.mainTrigger], "0");
      this.isOpen = false;
      setTimeout(() => {
          this.mainTrigger.focus();
        }, 0);
    } else {
      this.setAttribute("open", "");
      setTabindex(this.toggleTabindexElements, "0");
      setTabindex([this.mainTrigger], "-1");
      this.input.focus();
      this.input.setSelectionRange(
        this.input.value.length,
        this.input.value.length,
      );
      this.isOpen = true;
    }
  }

  toggleDrawerClasses() {
    this.onToggle();
    // this.fixOverlayIssue();
    this.drawer.classList.toggle(this.classDrawerActive);
    this.body.classList.toggle(this.activeOverlayBodyClass);
  }

  init() {
    this.triggers().forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleDrawerClasses();
      });
    });

    this.clearButton.addEventListener("click", () => {
      this.input.value = "";
      this.clearButton.style.display = "none";
      this.isVisibleClearButton = false;
      this.clearResults();
    });

    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.isOpen) {
          this.toggleDrawerClasses();
        }
      }

      if (isTabPressed) {
        if (this.isOpen) {
          if (e.shiftKey && document.activeElement === first) {
            last.focus();
            e.preventDefault();
          } else if (!e.shiftKey && document.activeElement === last) {
            first.focus();
            e.preventDefault();
          }
        }
      }
    });

    this.input.addEventListener("input", () => {
      if (this.input.value.length > 0 && !this.isVisibleClearButton) {
        this.clearButton.style.display = "flex";
        this.clearButton.setAttribute("tabindex", "0");
        this.isVisibleClearButton = true;
      } else if (this.input.value.length === 0 && this.isVisibleClearButton) {
        this.clearButton.style.display = "none";
        this.clearButton.setAttribute("tabindex", "-1");
        this.isVisibleClearButton = false;
      }
    });
  }

  hidePredictiveSearch() {
    // when predictive search is not available, we need to hide the predictive search results
    const featuresTag = document.getElementById("shopify-features");
    if (featuresTag) {
      const featuresData = JSON.parse(featuresTag.textContent);
      if (featuresData.predictiveSearch === false) {
        return false;
      }
    }
    return true;
  }

  // search stuff
  setupEventListeners() {
    const form = this.querySelector("form.store-search-form");
    form.addEventListener("submit", this.onFormSubmit.bind(this));
    if (this.isPredictiveSearchAvailable && this.isPredictiveSearchEnabled) {
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }

    if (Shopify.designMode) {
      document.addEventListener(
        "shopify:section:load",
        this.saveSuggestionMenuInDesignMode,
      );
    }
  }

  saveSuggestionMenuInDesignMode() {
    if (this.body.classList.contains(this.activeOverlayBodyClass))
      this.drawer.classList.toggle(this.classDrawerActive);
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (searchTerm.length) {
      this.getSearchResults(searchTerm);
      this.removeAttribute("empty");
    } else {
      this.clearResults();
    }
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent("resources[type]")}=product&${encodeURIComponent("resources[limit_scope]")}=each&${encodeURIComponent("resources[limit]")}=8&${encodeURIComponent("resources[options][fields]")}=${encodeURIComponent(this.searchProperties)}&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          let error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        const resultsMarkup = doc.querySelector("#shopify-section-predictive-search").innerHTML;

        // RANI CUSTOM (talep 2.1): Shopify Predictive Search synonym kullanmaz.
        // 0 ürün döndüyse full search (synonym destekli) fallback'ine düş.
        const productCount = doc.querySelectorAll('#predictive-search-results-list .search-result-list__item').length;
        if (productCount === 0) {
          this.tryFullSearchFallback(searchTerm, queryKey);
          return;
        }

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  // RANI CUSTOM (talep 2.1): Predictive 0 sonuç → full search (synonym destekli) fallback
  tryFullSearchFallback(searchTerm, queryKey) {
    const fullSearchUrl = `/search?q=${encodeURIComponent(searchTerm)}&type=product&section_id=main-search`;
    fetch(fullSearchUrl)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        // main-search section'ından ürün anchor'larını topla (handle bazlı dedup)
        const anchors = doc.querySelectorAll('a[href*="/products/"]');
        const handles = [];
        const seen = new Set();
        anchors.forEach((a) => {
          const m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
          if (m && !seen.has(m[1])) {
            seen.add(m[1]);
            handles.push(m[1]);
          }
        });
        if (handles.length === 0) {
          // Gerçekten hiç sonuç yok → mevcut empty state'i göster
          this.renderEmptyState(searchTerm);
          return;
        }
        // İlk 8 handle için JSON çek, basit kart listesi üret
        const top = handles.slice(0, 8);
        Promise.all(
          top.map((h) =>
            fetch(`/products/${encodeURIComponent(h)}.js`)
              .then((r) => (r.ok ? r.json() : null))
              .catch(() => null)
          )
        ).then((products) => {
          const valid = products.filter((p) => p && p.available !== false);
          if (valid.length === 0) {
            this.renderEmptyState(searchTerm);
            return;
          }
          const markup = this.buildFallbackMarkup(valid, searchTerm);
          this.cachedResults[queryKey] = markup;
          this.renderSearchResults(markup);
        });
      })
      .catch(() => {
        this.renderEmptyState(searchTerm);
      });
  }

  // RANI CUSTOM: Native predictive search markup'ını birebir taklit eder ki
  // Wonder default suggest-item CSS'i otomatik uygulansın (büyük resim, kompakt yazı).
  buildFallbackMarkup(products, searchTerm) {
    const fmt = (cents) => {
      const tl = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return tl + ' TL';
    };
    const esc = (s) => String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

    let html = '<div id="predictive-search-results" class="search-result">';
    html +=   '<div class="search-result-products">';
    html +=     '<div id="predictive-search-products" class="search-result__title">Ürünler</div>';
    html +=     '<ul id="predictive-search-results-list" class="search-result-list" role="listbox" aria-labelledby="predictive-search-products">';
    products.forEach((p, i) => {
      const img = (p.featured_image) || (p.images && p.images[0]) || '';
      const hasCompare = p.compare_at_price && p.compare_at_price > p.price;
      html +=     '<li id="predictive-search-option-' + (i + 1) + '" class="search-result-list__item" role="option" aria-selected="false">';
      html +=       '<a href="' + esc(p.url) + '" class="suggest-item" tabindex="-1">';
      if (img) {
        html +=       '<figure class="wt-cart__item__thumb suggest-item__thumb">';
        html +=         '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">';
        html +=       '</figure>';
      }
      html +=         '<div class="wt-cart__item__body suggest-item__body">';
      html +=           '<div class="wt-cart__item__data">';
      html +=             '<h3 class="wt-cart__item__name">' + esc(p.title) + '</h3>';
      if (typeof p.price === 'number') {
        html +=           '<div class="wt-cart__item__price">';
        html +=             '<div class="price' + (hasCompare ? ' price--on-sale' : '') + '">';
        if (hasCompare) {
          html +=             '<span class="price__sale">';
          html +=               '<s class="price-item price-item--regular">' + esc(fmt(p.compare_at_price)) + '</s>';
          html +=               '<span class="price-item price-item--sale">' + esc(fmt(p.price)) + '</span>';
          html +=             '</span>';
        } else {
          html +=             '<span class="price__regular"><span class="price-item price-item--regular">' + esc(fmt(p.price)) + '</span></span>';
        }
        html +=             '</div>';
        html +=           '</div>';
      }
      html +=           '</div>';
      html +=         '</div>';
      html +=       '</a>';
      html +=     '</li>';
    });
    html +=     '</ul>';
    html +=     '<div class="search-result-more search-result-more--desktop" role="option">';
    html +=       '<a href="/search?q=' + encodeURIComponent(searchTerm) + '&type=product" class="search-result-more__link">"' + esc(searchTerm) + '" için tüm sonuçları göster</a>';
    html +=     '</div>';
    html +=   '</div>';
    html += '</div>';
    return html;
  }

  // RANI CUSTOM: Gerçekten hiç sonuç bulunamadığında temiz empty state
  renderEmptyState(searchTerm) {
    const esc = (s) => String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const markup = '<div class="search-result search-result--no-results">' +
      '<div class="search-result-empty rani-predictive-empty">' +
        '<p class="rani-predictive-empty__msg">"' + esc(searchTerm) + '" için anlık öneri bulunamadı.</p>' +
        '<a href="/search?q=' + encodeURIComponent(searchTerm) + '&type=product" class="rani-predictive-empty__cta">Tüm arama sonuçlarını göster</a>' +
      '</div></div>';
    this.renderSearchResults(markup);
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    this.timeOut = setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    this.setAttribute("results", true);

    this.setLiveRegionResults();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        ?.textContent,
    );
  }

  clearResults() {
    this.input.value = "";
    this.removeAttribute("results");
    this.setAttribute("empty", true);
    this.statusElement.innerHTML = this.suggestionMenuContent.innerHTML || '';

    clearTimeout(this.timeOut);
    setTimeout(() => {
      this.statusElement.removeAttribute("aria-hidden");
    }, 300);
  }
}

customElements.define("search-drawer", DrawerSearchSection);
